export default (function (compareKey) {
  return function (input, formData) {
    if (!formData[compareKey]) return true;
    return input === formData[compareKey][0];
  };
});